import { useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import {
  removeSelectedRateOnStorage,
  getSelectedRateOnStorage,
  getSelectedRateKey,
} from 'models/payBySignage'
import { setRate } from 'redux-web/utils/payBySignage/actions'
import Text from 'components/Atoms/Text'
import Button from 'components/Atoms/Button'

const Component = styled.div`
  margin-bottom: 40px;
`

const Description = styled(Text)`
  margin-top: 5px;
`

const Selector = styled(Button)`
  min-height: 44px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 14px -4px rgba(0, 0, 0, 0.28);
  background-color: ${props => props.theme.palette.white};
  border-color: ${props => props.theme.palette.white};
  p {
    &:hover {
      opacity: 1;
    }
  }
`

const RateText = styled(Text)`
  text-transform: uppercase;
`

const RateSelector = ({ rates, lotId }) => {
  const dispatch = useDispatch()
  const { selectedRate } = useSelector(state => state.payBySignage)

  useEffect(() => {
    if (rates) {
      const selectedRateOnStorage = getSelectedRateKey(
        rates,
        getSelectedRateOnStorage(lotId)
      )

      if (selectedRateOnStorage) {
        if (selectedRate !== selectedRateOnStorage) {
          // SET SELECTED RATE BASED ON APPLE BUTTON CLICK
          dispatch(setRate(parseInt(selectedRateOnStorage)))
        }
        removeSelectedRateOnStorage(lotId)
      }
    }
  }, [rates])

  if (!rates) return null

  return (
    <Component>
      {rates.map(item => (
        <Selector
          key={item.key}
          onClick={() => {
            // CLEAR SELECTED RATE REFERENCE FOR APPLE LOGIN REDIRECTION
            removeSelectedRateOnStorage(lotId)
            dispatch(setRate(item.key))
          }}
          className={classNames('full', {
            highlight: selectedRate === item.key,
          })}>
          <Row between="xs" middle="xs">
            <Col xs={9}>
              <Text
                className={classNames('small', {
                  extraBold: selectedRate === item.key,
                  semiBold: selectedRate !== item.key,
                })}>
                {item.name}
              </Text>
              {item.description && (
                <Description className="semiBold tiny">
                  {item.description}
                </Description>
              )}
            </Col>
            <Col xs={3}>
              <RateText className="extraBold right small">
                {item.price || item.value}
              </RateText>
            </Col>
          </Row>
        </Selector>
      ))}
    </Component>
  )
}

RateSelector.propTypes = {
  rates: PropTypes.array,
  lotId: PropTypes.number,
}

export default RateSelector
